module.exports = "build/assets/theNewspaper.c7513c3f.png";